/** NIS / PIS / PASEP / NIT: 11 dígitos. */
export function stripNisDigits(value: string): string {
  return value.replace(/\D/g, '').slice(0, 11);
}

/** Máscara: 000.00000.00-0 */
export function formatNisDisplay(digits: string): string {
  const value = stripNisDigits(digits);

  if (value.length <= 3) {
    return value;
  }

  if (value.length <= 8) {
    return `${value.slice(0, 3)}.${value.slice(3)}`;
  }

  if (value.length <= 10) {
    return `${value.slice(0, 3)}.${value.slice(3, 8)}.${value.slice(8)}`;
  }

  return `${value.slice(0, 3)}.${value.slice(3, 8)}.${value.slice(8, 10)}-${value.slice(10)}`;
}
